import React from "react";
import { SpsButton } from "@spscommerce/ds-react";
import { SpsIcon, ButtonKind } from "@spscommerce/ds-shared";

import "./BannerMaxConnectBeta.scss";

const MAX_OPEN_BETA_URL = "https://go.spscommerce.com/max-open-beta";

function BannerMaxConnectBeta({ onDismiss }) {
    return (
        <div
            className="max-connect-beta-banner"
            role="region"
            aria-label="Max Connect beta announcement"
        >
            <div className="max-connect-beta-banner__inner">
                <p className="max-connect-beta-banner__message">
                    <span className="max-connect-beta-banner__spark">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            aria-hidden="true"
                        >
                            <path d="M11.017 2.814a1 1 0 0 1 1.966 0l1.051 5.558a2 2 0 0 0 1.594 1.594l5.558 1.051a1 1 0 0 1 0 1.966l-5.558 1.051a2 2 0 0 0-1.594 1.594l-1.051 5.558a1 1 0 0 1-1.966 0l-1.051-5.558a2 2 0 0 0-1.594-1.594l-5.558-1.051a1 1 0 0 1 0-1.966l5.558-1.051a2 2 0 0 0 1.594-1.594z"></path>
                            <path d="M20 2v4"></path>
                            <path d="M22 4h-4"></path>
                            <circle cx="4" cy="20" r="2"></circle>
                        </svg>
                    </span>
                    <b>Max Connect (MCP)</b> is now in beta. Connect your AI tools directly to SPS
                    network intelligence.
                </p>
                <a
                    className="max-connect-beta-banner__cta"
                    href={MAX_OPEN_BETA_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    Request Beta Access &#8594;
                </a>
                <div className="max-connect-beta-banner__close">
                    <SpsButton
                        onClick={onDismiss}
                        kind={ButtonKind.ICON}
                        icon={SpsIcon.X}
                        aria-label="Dismiss Max Connect announcement"
                    />
                </div>
            </div>
        </div>
    );
}

export default BannerMaxConnectBeta;
